import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDatepickerInputEvent, MatDialog } from "@angular/material";
import * as moment from "moment";
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddOfframpExpenseDialog } from "./add-offramp-expense/add-offramp-expense.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-expenses",
  templateUrl: "./offramp-expenses.component.html",
  styleUrls: ["./offramp-expenses.component.css"],
})
export class OfframpExpensesComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oExpenses: any = [];
  expenses: any = [];
  searchValue: string = '';
  filter: any = {
    page: 1,
    limit: 100,
    Category: '',
    fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;

  myFilter = (d: Date | null): boolean => {
    return true;
  };

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          if (params.node && params.node.rowPinned) {
            return document.createElement('div');
          }
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.style.marginRight = '5px';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          const deleteBtn = document.createElement('button');
          deleteBtn.type = 'button';
          deleteBtn.className = 'btn btn-sm btn-danger';
          deleteBtn.title = 'Delete';
          deleteBtn.innerHTML = '<i class="fa fa-trash"></i>';
          deleteBtn.onclick = (e) => {
            e.stopPropagation();
            this.deleteRecord(element);
          };
          container.appendChild(deleteBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 110
      },
      {
        headerName: 'Date',
        field: 'Date',
        cellRenderer: (params) => {
          if (params.node && params.node.rowPinned) return 'Total';
          return params.value ? moment(params.value).format('MMM DD, YYYY') : '';
        },
        flex: 1
      },
      { headerName: 'Category', field: 'Category', flex: 1 },
      { headerName: 'Details', field: 'Details', flex: 1.5 },
      {
        headerName: 'INR Received',
        field: 'INRReceived',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
      {
        headerName: 'Paid USDT',
        field: 'PaidUSDT',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
      {
        headerName: 'Total',
        field: 'Total',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
      { headerName: 'Notes', field: 'Notes', flex: 1.5 },
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
      getRowStyle: (params: any) => {
        if (params.node && params.node.rowPinned) {
          return { fontWeight: 'bold', background: '#f5f5f5' };
        }
        return null;
      }
    };
  }

  formatNumber(value: any, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    return Number(value).toLocaleString('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  computeTotals(list: any[]): any {
    const totals = {
      INRReceived: 0,
      PaidUSDT: 0,
      Total: 0
    };

    (list || []).forEach((expense: any) => {
      totals.INRReceived += expense.INRReceived || 0;
      totals.PaidUSDT += expense.PaidUSDT || 0;
      totals.Total += expense.Total || 0;
    });

    return totals;
  }

  updateTotalsRow() {
    if (this.gridApi) {
      this.gridApi.setPinnedBottomRowData([this.computeTotals(this.expenses)]);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.updateTotalsRow();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || '';
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpExpenses(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.expenses = list;
      this.oExpenses = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
      }

      this.updateTotalsRow();
      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch expenses", defaults.notif);
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      Category: '',
      fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
    this.searchValue = '';
    this.getData();
  }

  addNewRecord() {
    const dialogRef = this.dialog.open(AddOfframpExpenseDialog, {
      width: '600px',
      data: { record: {}, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Expense added successfully", defaults.notif);
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpExpenseDialog, {
      width: '600px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Expense updated successfully", defaults.notif);
        this.getData();
      }
    });
  }

  deleteRecord(record: any) {
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete this expense?`,
        buttonText: { ok: 'Yes', cancel: 'No' }
      }
    }).afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinnerService.show();
        this.offrampService.deleteOfframpExpense({ _id: record._id, _csrf: this._csrf }).subscribe(
          (response: any) => {
            this.spinnerService.hide();
            if (response.status || response.success) {
              this.notifSer.success("Success", response.message || "Expense deleted successfully", defaults.notif);
              this.getData();
            } else {
              this.notifSer.error("Error", response.message || "Failed to delete expense", defaults.notif);
            }
          },
          (error) => {
            this.spinnerService.hide();
            this.notifSer.error("Error", (error.error && error.error.message) || "Failed to delete expense", defaults.notif);
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-expenses/offramp-expenses.component.ts